// JsFromRoutes CacheKey bb627192b66188d535b6c9aa6b5969a6
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_sections/:hero_section_id/hero_section_items/search'),
  duplicate: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_section_items/:id/duplicate'),
  destroyAndDuplicate: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_section_items/:id/destroy_and_duplicate'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/hero_sections/:hero_section_id/hero_section_items'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_sections/:hero_section_id/hero_section_items'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/hero_section_items/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/hero_section_items/:id'),
}
